import FrameBase from './FrameBase';
import Communication from './Communication';
import AnalyticsDashboard from './AnalyticsDashboard';
import EngagementPreview from './EngagementPreview';
import ContactPreview from './ContactPreview';
import ContactActivityPreview from './ContactActivityPreview';
import EngagementEditor from './EngagementEditor';
import TaskPreview from './TaskPreview';
import Task from './Task';
export default {
  FrameBase: FrameBase,
  Communication: Communication,
  AnalyticsDashboard: AnalyticsDashboard,
  EngagementPreview: EngagementPreview,
  EngagementEditor: EngagementEditor,
  ContactPreview: ContactPreview,
  ContactActivityPreview: ContactActivityPreview,
  TaskPreview: TaskPreview,
  Task: Task
};